import type { IntegrationRequestFormSchema } from '../../../../models/IntegrationRequest';
import { FormTextAreaInput } from '@/components';
import type { Control } from 'react-hook-form';
import FormSection from './FormSection';

interface NotesSectionProps {
  control: Control<IntegrationRequestFormSchema>;
  disabled: boolean;
}

const NotesSection = ({ control, disabled }: NotesSectionProps) => (
  <FormSection title='Notas para TI'>
    <FormTextAreaInput control={control} name='notes' placeholder='Notas' rows={3} disabled={disabled} />
  </FormSection>
);

export default NotesSection;
